import React from "react";
import { Card } from "react-bootstrap";
import { i18n } from "app/i18n/i18n";
import { Pill } from "components/SearchBar/Pill";
import { Speakers, FormattedEventDate, WatchButton, RegisterButtonClick } from "pages/Events/parts/EventsPanelParts";
import { uniqueKey } from "lib/utils";
import { AddEventToCalendar } from "pages/Events/parts/AddEventToCalendar";
import defaultStyles from "./EventsCarouselCard.module.scss";
import grayTheme from "./themes/gray.module.scss";
import maroonTheme from "./themes/maroon.module.scss";

const langMap = {
  en: "English",
  ja: "Japanese",
};

// TODO: Remove this map and have props.uiHashtag return EQEvent as well
function getEQEventHashTag(tempHashtags) {
  return tempHashtags.filter((text) => text === "#EQEvent").map(() => "EQ Events");
}

export default function EventsCarouselCard(props) {
  const { slots, isFutureEvent, eventName, theme, uiHashtag, eventId, hashtag } = props || {};
  const [slotData] = slots || [];
  const { hashTags, locationCategory } = uiHashtag || {};
  const themeMap = {
    gray: grayTheme,
    maroon: maroonTheme,
  };
  const { container, borderTop, font, button } = themeMap[theme];
  const lang = i18n.getLanguage();
  const uiLang = langMap[lang];
  const hashtags = renderHashtags([...(hashTags || []), ...getEQEventHashTag(hashtag || [])]);
  const eventType = renderEventType(locationCategory);
  const languages = renderLanguages(slotData?.languages, uiLang);
  return (
    <Card className={`shadow w-100 ${defaultStyles.container} ${container}`}>
      <Card.Body className={defaultStyles.titleContainer}>
        <Card.Title className={`font-weight-lighter ${font} ${defaultStyles.title}`}>{eventName}</Card.Title>
        <Speakers speakers={slotData?.speakers} className={`${font} ${defaultStyles.speakers}`} />
      </Card.Body>

      <Card.Footer className={defaultStyles.eventPillsContainer}>
        <div className={defaultStyles.eventPills}>
          {hashtags}
          {eventType}
          {languages}
        </div>
      </Card.Footer>
      <Card.Footer className="border-top-0 d-flex flex-row justify-content-between">
        <Card.Text className="h6 mb-1 mr-2 mt-auto">
          <FormattedEventDate {...slotData} displayTime={true} fontClassName={font} breakDateAndTime />
        </Card.Text>
        {slotData?.locationURL ? (
          <AddEventToCalendar eventData={props} slotData={slotData} buttonClassName={button} />
        ) : null}
      </Card.Footer>
      <Card.Footer className={`mb-2 ${borderTop}`}>
        {isFutureEvent ? (
          <RegisterButtonClick locationURL={slotData?.locationURL} buttonClassName={button} eventId={eventId} />
        ) : (
          <WatchButton {...props} buttonClassName={button} />
        )}
      </Card.Footer>
    </Card>
  );
}

function EventPill(props) {
  return <Pill margin="mr-1 mb-2" cursor="cursor-auto" {...props} />;
}

function renderHashtags(hashtags) {
  return hashtags && hashtags.length
    ? hashtags.map((tag, idx) => {
        const key = uniqueKey(tag, idx);
        return <EventPill key={key} text={tag} />;
      })
    : null;
}

function renderEventType(eventType) {
  return eventType ? <EventPill text={eventType} /> : null;
}

function renderLanguages(languages, uiLang) {
  return languages.map((thisLang, idx) => {
    const key = uniqueKey(thisLang, idx);
    const tooltipText = `Language: ${thisLang}`;

    if (uiLang !== thisLang) {
      return <EventPill key={key} text={thisLang} title={tooltipText} />;
    }
  });
}
